// Stato di Sign in with Apple JS condiviso fra le istanze del modulo: sulla stessa
// pagina ne convivono piu' d'una (trovacigusto, header della home) e master-homepage
// carica questo file due volte, ma lo script va inserito e inizializzato una volta sola.
window.tgAppleSdk = window.tgAppleSdk || { promise: null, ready: false }

function AppleModule () {
  var self = this

  self.user = ko.observable(null)
  self.loading = ko.observable(false)
  self.image = ko.observable(null)
  self.registerType = ko.observable('user')
  self.invitationCode = ko.observable('')
  self.redirectCallback = function (redirectUrl) {
    location.href = redirectUrl
  }

  function appleIdAvailable () {
    return typeof AppleID !== 'undefined' && !!AppleID.auth
  }

  /**
   * Carica Sign in with Apple JS su richiesta, una volta sola, e lo inizializza.
   *
   * Prima appleid.auth.js era in fondo a ogni layout e AppleID.auth.init partiva nel
   * costruttore, cioe' su ogni pagina. Ora lo script arriva solo quando l'utente chiede
   * di accedere: al primo segnale di intento (vedi LoginRegisterModule.preloadSocialSdks)
   * o al click. AppleID si usa solo qui e nelle funzioni chiamate dopo il caricamento:
   * mai nel costruttore, dove un'eccezione lascerebbe la pagina senza binding.
   */
  self.loadSdk = function () {
    var sdk = window.tgAppleSdk
    if (sdk.promise) {
      return sdk.promise
    }

    sdk.promise = new Promise(function (resolve, reject) {
      var script = document.createElement('script')

      function fail () {
        sdk.promise = null
        if (script.parentNode) {
          script.parentNode.removeChild(script)
        }
        reject(new Error('Sign in with Apple JS non caricato'))
      }

      function initialize () {
        try {
          AppleID.auth.init({
            clientId: 'com.trovacigusto.signin',
            scope: 'name email',
            redirectURI: window.location.origin,
            state: 'Initial user authentication request',
            usePopup: true
          })
        } catch (e) {
          fail()
          return
        }

        document.addEventListener('AppleIDSignInOnSuccess', function (data) {
          console.log('AppleIDSignInOnSuccess', data)
        })
        document.addEventListener('AppleIDSignInOnFailure', function (error) {
          console.log('AppleIDSignInOnFailure', error)
        })

        sdk.ready = true
        resolve()
      }

      if (appleIdAvailable()) {
        initialize()
        return
      }

      script.async = true
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/it_IT/appleid.auth.js'
      script.onerror = fail
      script.onload = function () {
        if (appleIdAvailable()) {
          initialize()
        } else {
          fail()
        }
      }
      document.head.appendChild(script)
    })

    return sdk.promise
  }

  /**
   * Apre il popup di Sign in with Apple. Va chiamata dal gestore del click: i browser
   * (Safari soprattutto) aprono il popup solo se la chiamata parte in modo sincrono dal
   * gesto dell'utente, e succede se l'SDK e' gia' stato pre-caricato. Altrimenti lo si
   * carica e si apre dopo: se il browser blocca il popup, si invita a riprovare.
   */
  self.login = function () {
    if (window.tgAppleSdk.ready) {
      self.openSignIn()
      return
    }
    self.loadSdk()
      .then(self.openSignIn)
      .catch(function () {
        pNotify('Accesso con Apple non disponibile: non è stato possibile caricare lo script di Apple. Controlla eventuali blocchi del browser.', 'warning')
      })
  }

  self.openSignIn = function () {
    var request = null
    var blocked = socialLoginPopupBlocked(function () {
      request = AppleID.auth.signIn()
    })

    if (blocked) {
      pNotify('Il browser ha bloccato la finestra di accesso con Apple. Clicca di nuovo sul pulsante: ora è pronto. Se il blocco si ripete, consenti le finestre pop-up per questo sito.', 'warning')
    }

    if (request && typeof request.then === 'function') {
      request
        .then(function (response) {
          self.signIn(response)
        })
        .catch(function () {
          // Popup chiuso o accesso annullato: nessun avviso, come prima.
        })
    }
  }

  self.bindUser = function (appleUser, onSuccess) {
    self.loading(true)
    return rest('POST', '/api/v2/apple/signin', appleUser)
      .then(function (response) {
        if (response.success) {
          self.user(response.data)
          trovacigusto.loginRegisterModule.onesignalGetData()

          pNotify('Il tuo account Apple è stato collegato con successo')
          onSuccess(response)
        } else {
          pNotify('Il tuo account Apple non è stato collegato.', 'warning')
        }
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
  }

  self.signIn = function (response) {
    self.loading(true)
    //debugLog(response)
    var firstName
    var lastName
    var idToken
    if (response.idToken) {
      // native-only
      idToken = response.idToken
      firstName = response.firstName
      lastName = response.lastName
    } else {
      // browser-only
      if (response.authorization) {
        idToken = response.authorization.id_token
      }

      // Only shows once Apple only returns
      // the user object the first time
      // the user authorizes the app.
      // Persist this information from your app;
      // subsequent authorization requests won’t contain the
      // user object.
      if (response.user && response.user.name) {
        firstName = response.user.name.firstName
        lastName = response.user.name.lastName
      }
    }

    if (idToken) {
      const payloadObj = tgJwtPayload(idToken)
      if (payloadObj) {
        const { email, sub } = payloadObj

        const payload = {
          email: email,
          first_name: firstName,
          last_name: lastName,
          provider_type: 'apple',
          provider_token: idToken,
          provider_uid: sub,
          type: self.registerType(),
          invitationCode: self.invitationCode()
        }
        self.bindUser(payload, function (response) {
          self.redirectCallback(response.data.redirect ? response.data.redirect : '/');
        })
      }
    } else {
      pNotify('Si è verificato un errore. Non hai autorizzato correttamente il tuo account Apple', 'warning')
    }

  }

  self.unbindUser = function () {
    self.loading(true)
    rest('GET', '/api/v2/apple/unbind')
      .then(function (response) {
        if (response.status === 'user.reset.password') {
          self.user(null)
          pNotify('Il tuo account Apple è stato scollegato con successo. Devi impostare una password per poter accedere', 'warning')
        }
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
  }

  return self
}